import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/level/record/list'
    return request.post(url,data)
}

export function all() {
    let url = '/level/record/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/level/record/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/level/record/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/level/record/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/level/record/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/level/record/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/level/record/dmz/options'
    return request.get(url)
}

export function upload(file) {
    let url = '/level/record/upload';
    let forms = new FormData()
    forms.append("file",file)
    let config = {
        headers:{'Content-Type':'multipart/form-data'}
    }; //
    return request.post(url,forms,config)
}